import { useState, useEffect } from 'react';

import { fetchJSON } from '@client/utils/rest';

/**
 * useRestQuery - fetches data from a REST endpoint when endpoint/options change
 * @param {string} endpoint - The REST endpoint to call
 * @param {object} options - Options for fetchJSON (method, body, headers, etc)
 * @returns {object} { data, loading, error }
 */
export const useRestQuery = (endpoint, options = {}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!endpoint) return;

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await fetchJSON(endpoint, {
          credentials: 'include',
          ...options
        });
        setData(result);
      } catch (err) {
        setError(err);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [endpoint, JSON.stringify(options)]);

  return { data, loading, error };
};
